module.exports = __webpack_public_path__ + "static/media/container.b2780cc2.svg";